import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetSprints(data = {}) {
  const { enabled = false, configs = {}, topicId } = data;
  const { params = {} } = configs;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function listSprints() {
    return privateFetch.get(`/v1/admin/topic/${topicId}/sprint`, configs).then((res) => res.data);
  }

  return useQuery(['list-sprints', topicId], listSprints, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetSprints;
